import { dimensions } from './vars';

export const mediaQueries = {
  xs: `@media screen and (min-width: ${dimensions.breakpoints.xs})`,
  sm: `@media screen and (min-width: ${dimensions.breakpoints.sm})`,
  md: `@media screen and (min-width: ${dimensions.breakpoints.md})`,
  lg: `@media screen and (min-width: ${dimensions.breakpoints.lg})`,
  xl: `@media screen and (min-width: ${dimensions.breakpoints.xl})`,
};

/**
 * Some users might request for the site to limit "unnecessary" motion, this media query
 * helps us respect that
 * https://drafts.csswg.org/mediaqueries-5/#prefers-reduced-motion
 */
export const animationQuery = {
  acceptMotion: '@media (prefers-reduced-motion: no-preference)',
  reduceMotion: '@media (prefers-reduced-motion: reduce)',
};

/**
 * We should always aim for using mobile first design, which means we shouldn't need to use these media queries
 * However in certain circumstances, for example overriding a Radix style like in DropdownMenu, it can be acceptable
 */
export const mediaQueriesMobile = {
  xs: `@media screen and (max-width: ${dimensions.breakpointsMobile.xs})`,
  sm: `@media screen and (max-width: ${dimensions.breakpointsMobile.sm})`,
  md: `@media screen and (max-width: ${dimensions.breakpointsMobile.md})`,
  lg: `@media screen and (max-width: ${dimensions.breakpointsMobile.lg})`,
  xl: `@media screen and (max-width: ${dimensions.breakpointsMobile.xl})`,
};
